// extracted by mini-css-extract-plugin
export default {"SectionHeader":"SectionHeader_SectionHeader__5QHIW","NoCapitalization":"SectionHeader_NoCapitalization__P5mFR"};